import { useState } from 'react'
import { Organization_ } from 'src/api/db/apiOrgs'
import {
  ShippingLocation_,
  useShippingLocationsApi,
} from 'src/api/db/apiShippingLocations'
import { Column } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { AddEditShippingLocationDialog } from './components/AddEditShippingLocationDialog'
import { ShippingAddressesCard } from './components/ShippingAddressesCard'

export const ShippingLocations = ({
  organization,
}: {
  organization: Organization_
}) => {
  const { t } = useLocalization()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [editingLocation, setEditingLocation] = useState<
    ShippingLocation_ | undefined
  >()

  const { shippingLocations, isLoading, deleteShippingLocation } =
    useShippingLocationsApi({ org_id: organization.id })

  const handleDeleteAddress = async (id: number) => {
    if (
      window.confirm(
        t(
          'Are you sure you want to delete this location?',
          'Är du säker på att du vill ta bort denna plats?'
        )
      )
    ) {
      await deleteShippingLocation.mutateAsync(id)
    }
  }

  const handleEditAddress = (location: ShippingLocation_) => {
    setEditingLocation(location)
    setIsDialogOpen(true)
  }

  const handleAddLocation = () => {
    setEditingLocation(undefined)
    setIsDialogOpen(true)
  }

  const handleDialogClose = (open: boolean) => {
    setIsDialogOpen(open)
    if (!open) {
      setEditingLocation(undefined)
    }
  }

  return (
    <Column className="gap-6">
      <ShippingAddressesCard
        locations={shippingLocations || []}
        isLoading={isLoading}
        onAdd={handleAddLocation}
        onEdit={handleEditAddress}
        onDelete={handleDeleteAddress}
      />

      <AddEditShippingLocationDialog
        isModalOpen={isDialogOpen}
        setIsModalOpen={handleDialogClose}
        editLocation={editingLocation}
        org_id={organization.id}
      />
    </Column>
  )
}
